export default "__VITE_ASSET__CIKJM0s2__"